import { RadioButton } from 'src/modules/common/components/Radio/RadioButton';
import LM from 'src/modules/checkout/images/LM.png';
import LR from 'src/modules/checkout/images/LR.png';
import MR from 'src/modules/checkout/images/MR.png';
import { SelectValvePosition } from 'src/modules/checkout/types';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';

type Props = {
    valvePosition: SelectValvePosition;
    setValvePosition: (position: SelectValvePosition) => void;
}

export const SelectPosition = ({ valvePosition, setValvePosition }: Props) => (
    <div className="vss-select-position">
        <p className="vss-select-position__header">
            <I18n messageId={MESSAGES.checkoutSelectValvePositionTitle}/>
        </p>

        <div
            className="vss-select-position__wrapper"
        >
            <div
                className="vss-select-position__option"
                role="button"
                tabIndex={0}
                onClick={() => setValvePosition(SelectValvePosition.LM)}
                onKeyDown={() => null}
            >
                <img src={LM} alt="" className="vss-select-position__option-image"/>

                <div className="vss-select-position__option-content">
                    <p className="vss-select-position__option-header">
                        <I18n messageId={MESSAGES.checkoutSelectValvePositionLMHeader}/>
                    </p>
                    <p className="vss-select-position__option-description">
                        <I18n messageId={MESSAGES.checkoutSelectValvePositionLMDescription}/>
                    </p>
                </div>

                <RadioButton
                    id={SelectValvePosition.LM}
                    name="vss-select-valve-position"
                    onChange={() => setValvePosition(SelectValvePosition.LM)}
                    checked={valvePosition === SelectValvePosition.LM}
                />
            </div>

            <div
                className="vss-select-position__option"
                role="button"
                tabIndex={0}
                onClick={() => setValvePosition(SelectValvePosition.LR)}
                onKeyDown={() => null}
            >
                <img src={LR} alt="" className="vss-select-position__option-image"/>

                <div className="vss-select-position__option-content">
                    <p className="vss-select-position__option-header">
                        <I18n messageId={MESSAGES.checkoutSelectValvePositionLRHeader}/>
                    </p>
                    <p className="vss-select-position__option-description">
                        <I18n messageId={MESSAGES.checkoutSelectValvePositionLRDescription}/>
                    </p>
                </div>

                <RadioButton
                    id={SelectValvePosition.LR}
                    name="vss-select-valve-position"
                    onChange={() => setValvePosition(SelectValvePosition.LR)}
                    checked={valvePosition === SelectValvePosition.LR}
                />
            </div>

            <div
                className="vss-select-position__option"
                role="button"
                tabIndex={0}
                onClick={() => setValvePosition(SelectValvePosition.MR)}
                onKeyDown={() => null}
            >
                <img src={MR} alt="" className="vss-select-position__option-image"/>

                <div className="vss-select-position__option-content">
                    <p className="vss-select-position__option-header">
                        <I18n messageId={MESSAGES.checkoutSelectValvePositionMRHeader}/>
                    </p>
                    <p className="vss-select-position__option-description">
                        <I18n messageId={MESSAGES.checkoutSelectValvePositionMRDescription}/>
                    </p>
                </div>

                <RadioButton
                    id={SelectValvePosition.MR}
                    name="vss-select-valve-position"
                    onChange={() => setValvePosition(SelectValvePosition.MR)}
                    checked={valvePosition === SelectValvePosition.MR}
                />
            </div>
        </div>
    </div>
);
